@if (!task || loading) {
  <app-tasks-loading></app-tasks-loading>
}

@if (task) {
  <div class="task-details-component">
    <div
      class="task-header task-header flex justify-between items-center h-14 p-3 cool-gray-50 border-b-2 border-black-100"
    >
      <div class="text-lg font-medium capitalize">
        {{ taskTypeHumanLabel }}
      </div>
      <div class="task-actions flex">
        <button class="flex flex-row items-center mr-2" [matMenuTriggerFor]="moreMenu">
          <ts-icon color="black" icon="more_horiz"></ts-icon>
        </button>

        <mat-menu #moreMenu="matMenu">
          <button
            mat-menu-item
            (click)="duplicateTask()"
            [appAuthorize]="hasCreateTaskPermission"
            denyAction="disable"
            data-testid="task-details-duplicate-button"
          >
            <ts-icon icon="ts_copy" iconColor="black"></ts-icon>
            <span>Duplicate</span>
          </button>
          <button
            mat-menu-item
            (click)="deleteTask()"
            [appAuthorize]="hasDeletePermission"
            denyAction="disable"
            data-testid="task-details-delete-button"
          >
            <mat-icon [svgIcon]="'delete'"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>

        <button class="flex flex-row items-center" (click)="onClose()" data-testid="task-details-close-button">
          <ts-icon color="black" icon="close"></ts-icon>
        </button>
      </div>
    </div>

    <div class="task-form p-6">
      <form [formGroup]="taskForm">
        <ts-input
          type="text"
          label="{{ taskTypeHumanLabel }} title"
          placeholder="Title"
          formControlName="title"
          class="mb-3 capitalize"
          data-testid="task-details-title-input"
          [disabled]="!this.canEditTask"
        ></ts-input>

        @if (this.isTask || this.isKeyDate) {
          <app-task-details-start-due-date
            [canEditTask]="this.canEditTask"
            [task]="task"
            (updateTask)="onUpdateTask($event)"
            class="mb-3"
          />
        }

        @if (this.isKeyDate && isLinkingKeyDateEnabled) {
          <app-task-details-key-date-linking [task]="task" (updateTask)="onUpdateTask($event)" class="mb-3" />
        }

        @if (!this.isKeyDate) {
          <app-task-details-contacts
            class="mb-3"
            [task]="task"
            [canEditTask]="this.canEditTask"
            (contactRemove)="onContactRemove($event)"
            (contactAdd)="onContactAdd($event)"
          />
        }
        @if (!this.isKeyDate) {
          <app-task-details-assigned-to
            class="mb-3"
            [task]="task"
            [users]="users$ | async"
            [allowAssignToATaskRole]="!isGlobalTask"
            [canEditTask]="this.canEditTask"
            (assignedToChange)="onUpdateTask($event)"
          />
        }

        @if (this.isSection && false) {
          <mat-form-field class="flex-auto gt-xs:pr-3">
            <mat-label>Enable Section when Deal Reaches Status</mat-label>
            <mat-select
              [formControlName]="'project_stage_id'"
              panelClass="task-status-selector"
              [disabled]="!this.canEditTask"
            >
              <mat-option *ngFor="let projectStage of projectStages" [value]="projectStage.id">
                {{ projectStage.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        }

        <!-- approval permission on viewMode and feat -->
        @if (isApprovalFlowEnabled && !this.isKeyDate) {
          <task-approval
            [approvals]="task.approvals || []"
            [viewMode]="false || !hasApprovalPermission"
            (addApprover)="onApproverAdd($event)"
            (removeApprover)="onApproverRemove($event)"
          />
        }

        @if ((this.isTask || this.isKeyDate) && !this.isLinkingKeyDateReceiveFromField) {
          <div class="mt-4">
            <task-predecessors
              [rootTask]="task"
              [disabled]="!this.canEditTask"
              [taskPredecessorOptions]="taskPredecessorOptions"
              (navigateToTask)="goToTaskId($event)"
              (predecessorsUpdated)="onPredecessorsUpdate($event)"
            />
          </div>
        }

        @if (!this.isKeyDate) {
          <app-task-details-followers
            [disabled]="!this.canEditTask"
            [task]="task"
            [users]="users$ | async"
          ></app-task-details-followers>
        }
        <!-- Notes -->
        <div class="notes">
          <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              treoAutogrow
              [formControlName]="'description'"
              [spellcheck]="false"
              data-testid="task-details-description-input"
              [disabled]="!this.canEditTask"
            ></textarea>
          </mat-form-field>

          @if (linkedTasksFeatureEnabled && this.isTask) {
            <mat-form-field class="flex-auto gt-xs:pr-3 mt-2">
              <mat-label>Internal Value</mat-label>
              <input
                matInput
                data-testid="task-details-internal-value-input"
                [formControlName]="'internal_value'"
                [spellcheck]="false"
                [disabled]="!this.canEditTask"
              />
            </mat-form-field>
          }
        </div>

        @if (linkedTasksFeatureEnabled && this.isTask) {
          <app-task-details-linked-task
            [canEditTask]="this.canEditTask"
            [task]="task"
            [tasks]="onlyTasks"
            (saveTask)="onUpdateTask($event)"
            (unlinkTask)="onUnlinkTask($event)"
          />
        }

        @if (this.isTask && !isSubtask) {
          <app-task-details-subtasks
            [subTasks]="task.children"
            [canEditTask]="this.canEditTask"
            [taskListId]="task.task_list_id"
            (saveAndCreate)="onSaveSubtask($event)"
            (createSubtask)="onCreateSubtask()"
          />
        }

        @if ((this.isTask || this.isKeyDate) && taskList) {
          <task-details-checklist
            [canEdit]="this.canEditTask"
            [task]="task"
            (checkListUpdated)="onCheckListUpdated($event)"
          ></task-details-checklist>

          <app-tssk-details-custom-fields
            [task]="task"
            [taskList]="taskList"
            (updateTask)="onUpdateTask($event)"
            (updateTaskList)="onUpdateTaskList($event)"
          ></app-tssk-details-custom-fields>
        }

        @if (this.isTask) {
          <app-task-details-files
            [task]="task"
            [taskView]="taskList"
            [isGlobalTask]="isGlobalTask || isTaskListTemplate"
            [canEditTask]="this.canEditTask"
          />
        }

        @if (this.isTask || this.isKeyDate) {
          <div [attr.id]="commentViewFragment" class="mt-3" #commentView>
            @defer (on viewport(commentView)) {
              <comment-view
                [relatedToId]="task?.id"
                relatedToType="Task"
                (commentChanges)="onCommentChanges()"
              ></comment-view>
            } @placeholder {
              <div [ngStyle]="{ height: '500px' }"></div>
            }
          </div>
        }

        @if (!this.isKeyDate) {
          <p class="text-base font-medium mt-3 pr-3" #activities>Activity</p>
          @defer (on viewport(activities)) {
            <mat-divider
              role="separator"
              class="mat-divider mt-1 mat-divider-horizontal"
              aria-orientation="horizontal"
            ></mat-divider>
            <div class="flex flex-col max-h-120 overflow-y-auto">
              <shared-activity [activities]="activities$ | async" [relatedTo]="'Task'" />
            </div>
          }
        }
      </form>
    </div>

    @if (this.isTask) {
      <footer class="footer-content w-full sticky bottom-0">
        <app-task-details-footer [canEditTask]="canEditTask" [task]="task" (onUpdateTask)="onUpdateTask($event)" />
      </footer>
    }
  </div>
}
